import React from "react"
import { useAppContextState } from "app/@hooks"
import { createContext } from "use-context-selector"

const Context = createContext({})

// selectedGroupsByHotel: { [id_hotel]: [activeRateId, ...] }. Absent hotel => ALL rates active (default).
const initialState = {
    tableData: [],
    groupsGlobal: [],
    dates: [],
    isLoading: true,
    mainHotelIds: [],
    idMainHotel: null,
    selectedGroupsByHotel: {},
}

export function CompetitionAnalyzerGroupComparisonProvider({ children }) {
    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context
